import { wget } from 'lodash';

function isRouteDisabled(route) {
  return wget(route, 'disabled', false);
}

export default isRouteDisabled;
